import Icon from 'veui/components/Icon'
import { IconLink } from 'dls-icons-vue'

Icon.register('link', IconLink)
